<div *ngIf="data" class="container" [ngClass]="{'obert':paneDretaObert, 'tancat':!paneDretaObert, 'una':data.uniquePhase, 'multiple':!data.uniquePhase,
'plateAIncorrect':data.plateAIncorrect,'plateBIncorrect':data.plateBIncorrect,'plateCIncorrect':data.plateCIncorrect,'driverNameIncorrect':data.driverNameIncorrect,'driverPhoneIncorrect':data.driverPhoneIncorrect,'driverLegalIdentificationIncorrect':data.driverLegalIdentificationIncorrect,
'carrierNameIncorrect':data.carrierNameIncorrect,'carrierLegalIdentificationIncorrect':data.carrierLegalIdentificationIncorrect,'carrierAddressIncorrect':data.carrierAddressIncorrect,
'bannerHtml':data.bannerHtml, 'bannerText':data.bannerText}">
    <div class="block-esquerra">
        <div class="block-dades">
            <div class="canvi-dades" *ngIf="!data.readonly && !data.readonlyDataInfo && !requereixBooking()">
                <button-link class="link right important exworkgrotesque ng-star-inserted linpereditar" (click)="startEditmode()" *ngIf="!editMode">
                    <span>{{'SHARED.ACTIVE.SLOTS.ITEM.DRIVERPLATE.FORWARD.CAPTION' |
                        translate}}
                    </span>
                </button-link>
                <div class="zona-edit" *ngIf="editMode">
                    <div class="btn-close" (click)="cancel()">
                        <i class="fa fa-close"></i>
                    </div>
                    <div class="title d-block">{{ 'SHARED.EXWORK.EDIT.TITLE' | translateH }}</div>
                    <div class="help">
                        {{'SHARED.EXWORK.EDIT.HELP' | translate}}
                    </div>

                    <div class="data-block"
                        *ngIf="data.showAskCarrierName || data.showAskCarrierLegalIdentification || data.showAskCarrierAddress">
                        <span class="data-block-title">
                            <i class="fa fa-building" aria-hidden="true"></i>
                            <span class="title">
                                {{ 'SHARED.EXWORK.EDIT.CARRIER.TITLE' | translate}}
                            </span>
                        </span>
                        <input-component *ngIf="data.showAskCarrierName" class="col-x" [(ngModel)]="carrierName"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERNAME' | translate}}"></input-component>
                        <input-component *ngIf="data.showAskCarrierLegalIdentification" class="col-x"
                            [(ngModel)]="carrierLegalIdentification"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERLEGALIDENTIFICATION' | translate}}"></input-component>
                        <input-component *ngIf="data.showAskCarrierAddress" class="col-x" [(ngModel)]="carrierAddress"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.CARRIERADDRESS' | translate}}"></input-component>
                    </div>

                    <div class="data-block">
                        <span class="data-block-title">
                            <i class="fa fa-male" aria-hidden="true"></i>
                            <span class="title">
                                {{ 'SHARED.EXWORK.EDIT.DRIVER.TITLE' | translate}}
                            </span>
                        </span>
                        <input-component class="col-x" [(ngModel)]="driverName"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERNAME' | translate}}"></input-component>
                        <input-component class="col-x" [(ngModel)]="transportationRegistrationCode"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.TRANSPORTATIONREGISTRATIONCODE' | translate}}"></input-component>
                        <input-component class="col-x" [(ngModel)]="driverLegalIdentification"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERLEGALIDENTIFICATION' | translate}}"></input-component>

                        <input-component class="col-x" [(ngModel)]="driverPhone"
                            placeholder="{{'ROUTEPAGE.ITEM.EDIT.DRIVERPHONE' | translate}}"></input-component>
                    </div>

                    <div class="data-block">
                        <span class="data-block-title">
                            <i class="fa fa-truck" aria-hidden="true"></i>
                            <span class="title">
                                {{ 'SHARED.EXWORK.EDIT.PLATES.TITLE' | translate}}
                            </span>
                        </span>
                        <div class="col-x">
                            <input-component class="col-plate" [(ngModel)]="plateA"
                                placeholder="{{'ROUTEPAGE.ITEM.EDIT.PLATEA' | translate}}"></input-component>
                            <input-component class="col-plate" [(ngModel)]="plateB"
                                placeholder="{{'ROUTEPAGE.ITEM.EDIT.PLATEB' | translate}}"></input-component>
                            <input-component *ngIf="!data.hidePlateC" class="col-plate" [(ngModel)]="plateC"
                                placeholder="{{ data.resourcePlateC | translate}}"></input-component>
                        </div>
                    </div>

                    <shared-savebutton class="botodesar" (save)="save($event)">
                        {{'SHARED.EXWORK.DRIVER.BUTTON.SAVE' | translate}}
                    </shared-savebutton>
                </div>
            </div>
        </div>
    </div>
</div>